// The first parameter received is the event from onClick, and the second parameter is the entire data value. See /Simple/Data.js#useDataChange
export function not(_, value) {
  return !value.sidebar_toggles.is_chairs_sidebar_open
}
